import { ApiError } from '../response';

class ApiException extends Error {
  private issues?: ApiError[];

  constructor(msg: string, issues?: ApiError[]) {
    super(msg);
    this.issues = issues;
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ApiException.prototype);
  }

  getIssues() {
    return this.issues;
  }
}

export { ApiException };
